<template>
  <el-dialog
      :visible.sync="visible"
      title="成品配件批量发货导入"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <div class="table-bar" style="justify-content: flex-start;margin-bottom: 0px">
        <div class="bar-item">
          <UploadButton url="/erp/excel/file/product/send" @success="readFileSuccess"></UploadButton>
        </div>
        <FileLink file-type="front" file-url="/static/template/成品配件批量发货导入.xlsx" class="bar-item">下载模板
        </FileLink>
      </div>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500"
                  :summaries-column="['totalAmount','totalCount']" :row-style="rowStyleHandler">
        <el-table-column label="外销合同号" prop="orderCode" align="center">
        </el-table-column>
        <el-table-column
            label="发货方"
            prop="senderName"
            header-align="center"
            align="center" :show-overflow-tooltip="true" :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column
            label="收货方"
            prop="receiverName"
            header-align="center"
            align="center" :show-overflow-tooltip="true" :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column label="品番号" prop="product.code"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="SKU" prop="product.skuCode"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="品名" prop="product.name"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="颜色" prop="product.color"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="规格" prop="product.size"
                         align="center" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column label="发货数量" prop="sendCount"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>

        <el-table-column label="发货日期" width="120" prop="sendDate" align="center">
        </el-table-column>
        <el-table-column
            label="错误提示"
            prop="errorMsg"
            header-align="center"
            align="center" :show-overflow-tooltip="true">
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button size="mini" @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="doSave" :disabled="!canSubmit">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 供应商成品发货弹窗
 */
import UploadButton from '@/components/UploadButton.vue'
import debounce from 'lodash/debounce'
import { countValidator, moneyValidator } from '@/utils/validate'
import ProductRowCard from '@/components/ProductRowCard.vue'
import moment from 'moment'
import BigNumber from 'bignumber.js'
import ImportErrorCard from '@/components/ImportErrorCard.vue'
import FileLink from '@/components/FileLink.vue'

export default {
  name: 'ProductImportDialog',
  components: { FileLink, ProductRowCard, UploadButton },
  data () {
    return {
      visible: false,
      dataForm: {},
    }
  },
  computed: {
    dataRule () {
      return {}
    },
    canSubmit () {
      if (!this.dataForm || !this.dataForm.detailList) {
        return false
      }
      let hasError = this.dataForm.detailList.every(item => !item.errorMsg)
      return hasError
    }
  },
  methods: {
    rowStyleHandler ({ row, rowIndex }) {
      if (row.errorMsg) {
        return {
          color: 'red'
        }
      }
    },
    readFileSuccess (result) {
      this.dataForm.detailList = result
    },
    init (detailList) {
      this.dataForm = {
        detailList: detailList,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    async doSave () {
      let postForm = []
      this.dataForm.detailList.forEach(row => {
        postForm.push({
          sourceType: 'make',
          senderId: row.senderId,
          sourceId: row.makeDetailId,
          sourceTable: 'ma_factory_make_detail',
          productId: row.productId,
          sendCount:row.sendCount,
          receiverId: row.receiverId,
          receiverName: row.receiverName,
          operateTime: row.sendDate
        })
      })
      const loading = this.$loading()
      try {
        const res = await this.$api2.post('/trade/factorystorelog/send', postForm)
        this.$emit('changed')
        this.visible = false
        this.dataForm.detailList = []
      } finally {
        loading.close()
      }
    }
  },
}
</script>

